import React, { Component, PropTypes } from 'react';
import Autosuggest from 'react-autosuggest';

import { debounce } from 'lodash';

import moment from 'moment';

import { NitroPlaceholder, NitroDatePicker, NitroText } from 'nitro-components';

import styled from 'styled-components';

import {
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SELECT_EXISTING_DRIVER_SRCH_DRVR_NAME,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SET_ALLOC_DATE
} from '../content';

import DriverAllocationApi from '../../../../api/DriverAllocationApi';

const RegoNo = styled.div`color: ${props => props.theme.color.base3};`;

const Suggestion = styled.div`
  display: flex;
  justify-content: space-between;
`;

const AutoComplete = styled.div`
  .react-autosuggest__container {
    position: relative;
  }
  .react-autosuggest__input {
    width: 100%;
    height: 48px;
    padding: 10px 20px;
    font-family: ${props => props.theme.font.default};
    font-weight: 300;
    font-size: 14px;
    border: 1px solid ${props => props.theme.color.border};
    border-radius: 4px;
    color: ${props => props.theme.color.base2};
  }
  .react-autosuggest__input--focused {
    outline: none;
  }
  .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .react-autosuggest__suggestions-container {
    display: none;
  }

  .react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    width: 100%;
    border: 1px solid ${props => props.theme.color.border};
    background-color: ${props => props.theme.color.white};
    font-family: ${props => props.theme.font.default};
    color: ${props => props.theme.color.base2};
    font-weight: 300;
    font-size: 14px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 2;
    border-top: none;
    max-height: 180px;
    overflow-y: auto;
    box-shadow: ${props => props.theme.boxShadow['3']};
    border-radius: 2px;
  }

  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
  }

  .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
  }
`;

const renderSuggestion = suggestion => {
  return (
    <Suggestion>
      <NitroText bold>
        {suggestion.DriverFirstName} {suggestion.DriverSurname}{' '}
      </NitroText>

      <RegoNo>
        {suggestion.EmployeeNo}
      </RegoNo>
    </Suggestion>
  );
};

class ExistingDriverTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTermvalue: '',
      suggestions: []
    };
    this.onSuggestionsFetchRequestedDebounced = debounce(this.onSuggestionsFetchRequestedDebounced, 500);
  }

  onChange = (event, { newValue, method }) => {
    this.setState({
      searchTermvalue: newValue
    });
  };

  onSuggestionsFetchRequestedDebounced = value => {
    DriverAllocationApi.getDrivers({
      countryCode: this.props.country.value,
      lookup: value,
      companyCode: this.props.company.value,
      searchType: 'ALL'
    })
      .then(data => {
        this.setState({
          suggestions: data.data.Details
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.props.setDriverDetails({
      target: { name: 'existingDriver', value: null }
    });
    this.onSuggestionsFetchRequestedDebounced(value);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getSuggestionValue = suggestion => {
    this.props.setDriverDetails({
      target: { name: 'existingDriver', value: suggestion }
    });
    return `${suggestion.DriverFirstName} ${suggestion.DriverSurname}`;
  };

  setAllocationDate = date => {
    this.props.setDriverDetails({
      target: { name: 'existingDriverAllocationDate', value: date }
    });
  };

  render() {
    const { searchTermvalue, suggestions } = this.state;
    const inputProps = {
      placeholder: ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SELECT_EXISTING_DRIVER_SRCH_DRVR_NAME,
      value: searchTermvalue,
      onChange: this.onChange
    };

    const { existingDriverAllocationDate } = this.props.driverDetails;
    // TODO: Find out what is the requirement here.
    const minDate = moment().subtract(1, 'month').toDate();
    return (
      <div>
        <NitroPlaceholder size={40} />

        <AutoComplete>
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
          />
        </AutoComplete>

        <NitroPlaceholder size={30} />

        <NitroDatePicker
          placeholder={ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SET_ALLOC_DATE}
          value={existingDriverAllocationDate}
          onChange={this.setAllocationDate}
          minDate={minDate}
        />

        <NitroPlaceholder size={30} />
      </div>
    );
  }
}

ExistingDriverTab.propTypes = {
  country: PropTypes.object,
  company: PropTypes.object,
  driverDetails: PropTypes.object,
  setDriverDetails: PropTypes.func
};

export default ExistingDriverTab;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/ExistingDriverTab.js